import classNames from "classnames/bind";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

export default function Button({children, type = "default", htmlType, onClick, className, isValid}) {
  return (
    <button className={cn("container", type, className && className, isValid && "selected")} type={htmlType || "button"} onClick={onClick}>
      {children}
    </button>
  );
}
